import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/data/data.service';
import { ConfigurationPackage } from '../models/configurationPackage';
import { FunctionsService } from 'src/app/data/functions.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-packer',
  templateUrl: './packer.component.html',
  styleUrls: ['./packer.component.css']
})
export class PackerComponent implements OnInit {
  boxes: ConfigurationPackage[] = [];
  public loading: boolean = false;
  product = {
    height: 0,
    width: 0,
    length: 0,
    weight: 0,
    quantity: 1,
  };
  betterPackage: ConfigurationPackage[] | any[] = null;

  constructor(private dataService: DataService, private functions: FunctionsService) { }

  ngOnInit(): void {
    this.dataService.getAllBoxes().then(data => {
      if (data) this.boxes = data as ConfigurationPackage[]
      console.log(data)
    })
  }

  getImageModel(model: string): string {
    return `assets/images/boxes-correios/${model}.jpg`;
  }

  getImageIdealTo(model: string): string {
    return `assets/images/boxes-correios/${model} - Ideal.jpg`;
  }
  calculateBetterPackage(): void {
    this.loading = true
    this.functions.calculatePackageDimensions(this.product).pipe(
      finalize(() => {
        this.loading = false
      })
    )
      .subscribe({
        next: res => {
          this.betterPackage = res.body.data;
        }
      })
    // this.boxes.find(config =>
    //   config.Altura >= this.product.height &&
    //   config.Largura >= this.product.width &&
    //   config.Comprimento >= this.product.length
    // ) || null;
    console.log(this.betterPackage)
  }
}
